<script lang="ts" setup>
  defineProps<{ title: string }>();
</script>

<template>
  <article class="host-error-message">
    <h1>{{ title }}</h1>
    <slot />
  </article>
</template>

<style scoped>
  .host-error-message {
    display: flex;
    flex-direction: column;
    font-size: var(--font-size-sm);
    gap: 1.75rem;
    line-height: 1.5;
    max-width: var(--control-max-width);
    width: 100%;
  }

  h1 {
    font-size: var(--font-size-xl);
    line-height: 1.2;
    margin: 0;
    text-align: center;
  }

  :slotted(p) {
    color: var(--color-text-secondary);
    margin: 0;
    text-align: center;
  }

  :slotted(ol) {
    color: var(--color-text-secondary);
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    margin: 0;
    padding-left: 1.5rem;
  }

  :slotted(li)::marker {
    color: var(--color-primary);
    font-weight: bold;
  }
</style>
